import React from "react";
import { useLiff } from "react-liff";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";

import CookieSettingPopup from "../../components/popup/CookieSettingPopup";
import house from "../../assets/images/house.svg";

import edit from "../../assets/images/icon/edit.svg";
import TopLogo from '../../components/layout/TopLogo';
import TopBanner from '../../components/layout/TopBanner';
import background from '../../assets/images/bg-info.png';
import { SearchEmployee } from "../../services/Shop";
import { useDispatch } from 'react-redux';
import { setShop } from "../../features/ShopSlice";
import TopBtnShop from "../../components/layout/TopBtnShop";

export default function ShopInfoMain() {
  const dispatch = useDispatch();

  const [address, setAddress] = React.useState(true);
  const [employee, setEmployee] = React.useState({
    email: '',
    firstName: '',
    lastName: '',
    mobileNumber: '',
    birthdate: null,
  });

  const [openCookiePopup, setOpenCookiePopup] = React.useState(false);

  const navigate = useNavigate();

  const [page, setPage] = React.useState("info");

  const { liff } = useLiff();
  const lineId = liff.getDecodedIDToken().sub;

  React.useEffect(() => {
    getSearchEmployee()
  }, []);

  async function getSearchEmployee() {
    return await SearchEmployee({ lineId })
      .then(async (response) => {
        if (+response.data.resultCode !== 20000) {
          navigate("/register");
        } else {
          setEmployee(response.data.body)
          fnSetData('shopId', response.data.body.shopId)
          fnSetData('shopName', response.data.body.shopName)
          if (response.data.body.isOwner) {
            fnSetData('isOwner', true)
            fnSetData('ownerId', response.data.body.employeeId)
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const goToEdit = () => {
    const data = {
      email: employee.email,
      firstName: employee.firstName,
      lastName: employee.lastName,
      mobileNumber: employee.mobileNumber,
      birthdate: employee.birthdate,
    }
    navigate('/shop-info-edit-profile', {
      state: {
        payload: data
      }
    });
  }


  const goToEditAddress = () => {
    const data = {
      shopName: employee.shopName,
      shopId: employee.shopId,
      addressDetails: employee.addressDetails,
      district: employee.districtName,
      amphoe: employee.amphoeName,
      province: employee.provinceName,
      zipCode: employee.zipCode,
      isDeliveryAddress: employee.isDeliveryAddress,
      deAddressDetails: employee.deAddressDetails,
      deDistrict: employee.deDistrictName,
      deAmphoe: employee.deAmphoeName,
      deProvince: employee.deProvinceName,
      deZipCode: employee.deZipCode,
    }
    navigate('/shop-info-edit-address', {
      state: {
        payload: data
      }
    });
  }



  function UserInfo(title, data) {
    return (
      <div className="flex justify-between items-start">
        <p className="text-gray text-[20px] whitespace-pre-line leading-[24px]">
          {title}:
        </p>
        {data ? (
          <div className="max-w-[200px] text-right text-darkGray text-[20px] whitespace-pre-line leading-[24px]">
            {data}
          </div>
        ) : (
          <p className="text-darkGray text-[20px]">-</p>
        )}
      </div>
    );
  }

  function fnSetData(name, value) {
    const tmpObj = {};
    tmpObj[name] = value;
    dispatch(setShop(tmpObj));
  }


  return (
    <div id="shop-page">
      <TopLogo />
      <TopBanner type="shopInfo" />
      <CookieSettingPopup
        open={openCookiePopup}
        onClose={() => {
          setOpenCookiePopup(false);
        }}
      />
      {/*<img src={ShopBanner} alt="shopbanner" className="w-full" />*/}
      <div id="shop" style={{
        backgroundImage: `url(${background})`,
        minHeight: "calc(100vh - 60px)",
        padding: "20px",
      }}
        className="gradientBg px-[20px] mt-[-40px]">
        <TopBtnShop type="info" isOwner={employee.isOwner} />
        {/* <img src={bgInfo} alt="logo" style={{ width: "100%" }} /> */}
        <div className="bg-white rounded-[10px] mt-[10px]">
          <div className="flex items-center">
            <p
              onClick={() => setPage("info")}
              className={
                `w-full text-[20px] text-gray text-center py-[9px] border-b-[1px] border-lightGray ` +
                (page === "info" && "!text-blue !border-b-[4px] !border-blue")
              }
            >
              ข้อมูลของฉัน
            </p>
            <p
              onClick={() => setPage("address")}
              className={
                `w-full text-[20px] text-gray text-center py-[9px] border-b-[1px] border-lightGray ` +
                (page === "address" &&
                  "!text-blue !border-b-[4px] !border-blue")
              }
            >
              ข้อมูลร้านค้า
            </p>
          </div>

          {page === "info" ? (
            <div className="p-[16px]">
              <div className="flex gap-[10px] justify-start">
                <div className="primary-color title-size">ข้อมูลของฉัน</div>
                <div style={{ marginTop: "6px" }}>
                  <p className="sub-title-size"> My Information</p>
                  <div className="blue-line" ></div>
                </div>
              </div>
              <div className="flex flex-col gap-[8px] mt-[10px]">
                {UserInfo(
                  "ชื่อ - นามสกุล",
                  `${employee.firstName} ${employee.lastName}`
                  // "วินัย พิมพ์นิยมตระกูล"
                )}
                {UserInfo(
                  "ตำแหน่ง",
                  `${employee.isOwner ? 'เจ้าของร้าน' : 'พนักงาน'}`
                  // "วินัย พิมพ์นิยมตระกูล"
                )}
                {UserInfo(
                  "อีเมล",
                  `${employee.email || 'กรุณากรอกข้อมูล'}`
                )}
                {UserInfo(
                  "วัน/เดือน/ปี เกิด",
                  `${employee.birthdate ? dayjs(employee.birthdate, 'YYYY-MM-DD').format('DD/MM/YYYY') : '-'}`
                )}
                {UserInfo(
                  "เบอร์โทรศัพท์",
                  `${employee.mobileNumber || 'กรุณากรอกข้อมูล'}`
                )}
              </div>
              <button
                onClick={goToEdit}
                className="mt-[20px] w-fit flex gap-[5px] items-center justify-center py-[1px] px-[20px] rounded-[5px] border-[1px] border-blue"
              >
                <img className="w-[10px]" src={edit} alt="" />
                <p className="text-blue text-[20px]">แก้ไขข้อมูล</p>
              </button>

            </div>
          ) : (
            <div className="p-[16px]">
              <div className="flex gap-[10px] justify-start">
                <div className="primary-color title-size">ข้อมูลร้านค้า</div>
                <div style={{ marginTop: "6px" }}>
                  <p className="sub-title-size"> Store Information</p>
                  <div className="blue-line" ></div>
                </div>
              </div>

              {address ? (
                <div>
                  <div className="flex flex-col gap-[12px] mt-[10px]">
                    {UserInfo("ชื่อร้านค้า", `${employee.shopName || '-'}`)}
                    {UserInfo("รหัสร้านค้า", `${employee.shopCode || '-'}`)}
                    {UserInfo("ที่อยู่", `${employee.addressDetails || '-'}`)}
                    {UserInfo("แขวง/ตำบล", `${employee.districtName || '-'}`)}
                    {UserInfo("เขต/อำเภอ", `${employee.amphoeName || '-'}`)}
                    {UserInfo("จังหวัด", `${employee.provinceName || '-'}`)}
                    {UserInfo("รหัสไปรษณีย์", `${employee.zipCode || '-'}`)}
                  </div>

                  {employee.isOwner && <button
                    onClick={goToEditAddress}
                    className="mt-[20px] w-fit flex gap-[5px] items-center justify-center py-[1px] px-[20px] rounded-[5px] border-[1px] border-blue"
                  >
                    <img className="w-[10px]" src={edit} alt="" />
                    <p className="text-blue text-[20px]">แก้ไขข้อมูล</p>
                  </button>
                  }
                </div>
              ) : (
                <div>
                  <img
                    className="mx-auto mt-[20px]"
                    src={house}
                    alt="logo"
                    style={{ width: "40%", opacity: "0.6", mixBlendMode: "luminosity" }}
                  />
                  <p className="text-[20px] text-center mt-3">
                    คุณยังไม่ได้ระบุที่อยู่ โปรดระบุที่อยู่ของคุณ
                  </p>

                  {/* <button
                    onClick={goToAddAddress}
                    className="mx-auto mt-[50px] w-fit flex gap-[5px] items-center justify-center py-[1px] px-[20px] rounded-[5px] border-[1px] border-blue"
                  >
                    <img className="w-[10px]" src={edit} alt="" />
                    <p className="text-blue text-[20px]">เพิ่มที่อยู่</p>
                  </button> */}
                </div>
              )}
            </div>
          )}
        </div>


        <br></br>
        <br></br>

      </div>
    </div>
  )
}